import React from "react";
import { useOutletContext } from "react-router-dom";
import AboutUs from "../components/about_us";
import Faq from "../components/Faq";
import Cta from "../components/Cta";
import styles from "./HomePage.module.css";

export default function HomePage() {
  const { content, isRtl, text } = useOutletContext();

  const aboutTitle = isRtl ? text.Arabic9 : text.aboutUs;

  return (
    <div className={styles.home}>
      <AboutUs title={aboutTitle} description={content?.about_us} />
      <Faq
        isRtl={isRtl}
        faqheading={isRtl ? text.Arabicfaq : text.Engfaq}
        faqContent={content.faq || ""}
      />
      {isRtl ? (
        <Cta
          title={text.Arabic8}
          description={text.Arabicdescription8}
          socialLinks={content?.social_links}
        />
      ) : (
        <Cta
          title={text.Eng8}
          description={content.cta_content || ""}
          socialLinks={content?.social_links}
        />
      )}
    </div>
  );
}
